export default {"src":"/_next/static/media/forum.9f554b55.svg","height":256,"width":352,"blurWidth":0,"blurHeight":0};